import { render, staticRenderFns } from "./PagoView.vue?vue&type=template&id=8bd28fca&scoped=true"
import script from "./PagoView.vue?vue&type=script&lang=js"
export * from "./PagoView.vue?vue&type=script&lang=js"
import style0 from "./PagoView.vue?vue&type=style&index=0&id=8bd28fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd28fca",
  null
  
)

export default component.exports